<script lang="ts">
	import type { Category, InventoryType } from 'utility/search-fields'
	import type { i18n } from 'types/common'

	import Autocomplete from '@isoftdata/svelte-autocomplete'
	import { loadCategories } from 'utility/search-fields'
	import { untrack, type ComponentProps, type Snippet } from 'svelte'
	import { getContext } from 'svelte'

	interface Props extends Omit<ComponentProps<typeof Autocomplete<Category | null>>, 'value' | 'options' | 'getLabel'> {
		category?: Category | null
		initialValue?: string
		inventoryType: InventoryType | null
		disabled?: boolean
		vehicle?: boolean
		hint?: Snippet
	}

	let {
		category = $bindable(null),
		initialValue,
		inventoryType,
		disabled = false,
		vehicle = false,
		...rest
	}: Props = $props()

	let categoryList: Promise<Array<Category>> | Array<Category> = $state([])

	const { t: translate } = getContext<i18n>('i18next')

	async function loadCategoryListAndSet(inventoryType: InventoryType | null) {
		if (!inventoryType) {
			categoryList = []
			category = null
		} else {
			categoryList = loadCategories(inventoryType?.id)
			categoryList.then(categories => {
				categoryList = categories
				if (initialValue) {
					category = categories.find(categoryListItem => categoryListItem.name === initialValue) ?? null
				}
				//If we have a selected category but after loading the new list, it's not in the list, then we need to the clear the selection
				else if (category && !categories.find(categoryListItem => categoryListItem.id === category?.id)) {
					category = null
				}
			})
		}
	}

	$effect(() => {
		inventoryType
		untrack(() => loadCategoryListAndSet(inventoryType))
	})
</script>

<Autocomplete
	{...rest}
	label={translate('common:category', 'Category')}
	placeholder={inventoryType
		? `-- ${translate('search.customizeYourSearchHelpText.selectACategory', 'Select a Category')} --`
		: `${vehicle ? translate('search.selectAUnitTypeFirst', 'Select a unit type first') : translate('search.selectAnInventoryTypeFirst', 'Select an inventory type first')} `}
	disabled={disabled || !inventoryType}
	options={categoryList}
	emptyValue={null}
	bind:value={category}
	getLabel={option => option?.name ?? ''}
></Autocomplete>
